module.exports = __webpack_public_path__ + "static/278-ee0220f2cc2d7934bf51a69c140f02b4.jpg";